import React, { useState, useMemo, useEffect } from "react";
import { feesAPI,studentsAPI } from "../../services/api";



const initialPayments = [
    {
        id: 1,
        date: "Jul 26th 2025",
        amount: "Rs. 11,000",
        invoice: "STPS-58",
        mode: "Cash",
        description: "",
        cancelReason: "",
    },
    {
        id: 2,
        date: "Jul 23rd 2025",
        amount: "Rs. 5,000",
        invoice: "STPS-7",
        mode: "Cash",
        description: "",
        cancelReason: "",
    },
    {
        id: 3,
        date: "Jul 23rd 2025",
        amount: "Rs. 5,000",
        invoice: "STPS-8",
        mode: "Cheque",
        description: "",
        cancelReason: "",
    },
    {
        id: 4,
        date: "Jul 23rd 2025",
        amount: "Rs. 1,000",
        invoice: "STPS-9",
        mode: "Cash",
        description: "",
        cancelReason: "",
    },
];

// Generates the printable / downloadable HTML invoice that matches the
// "SRINI THE PLAY SCHOOL & ACADEMY" invoice design.
// Renders a single invoice box. isDuplicate adds the "DUPLICATE" label
// above "Invoice" in the meta block, matching the second copy in the
// reference design.
const renderInvoiceBox = (
    payment,
    academicYear,
    student,
    isDuplicate
) => {
    const amountClean = String(payment.amount || "")
        .replace(/^Rs\.?\s*/i, "");

    return `
  <div class="invoice-box">

    <div class="header-row">

      <div class="brand">
        <div class="brand-badge">SRINI</div>

        <div class="brand-name">
          SRINI THE PLAY SCHOOL &amp; ACADEMY
        </div>
      </div>

      <div class="header-right">

        <div class="invoice-title">
          INVOICE
        </div>

        <div class="meta">

          ${
              isDuplicate
                  ? '<div class="duplicate-label">DUPLICATE</div>'
                  : ""
          }

          <div>
            <span class="meta-label">
              Invoice
            </span>
            #${payment.invoice}
          </div>

          <div>
            <span class="meta-label">
              Date
            </span>
            ${payment.date}
          </div>

          <div>
            <span class="meta-label">
              Academic Year
            </span>
            ${academicYear || ""}
          </div>

        </div>
      </div>
    </div>

    <div class="info-row">

      <div class="bill-to">

        <div class="bill-to-label">
          Bill To
        </div>

        <div class="name">
          ${student?.studentName || ""}
        </div>

        <div>
          ${student?.className || student?.class || ""}
          ${student?.sectionName || student?.section || ""}
        </div>

        <div>
          ${student?.guardianName || student?.fatherName || ""}
        </div>

        <div>
          ${student?.phone || student?.mobileNumber || "NA"}
        </div>

      </div>

      <div class="paid-box">

        <div class="label">
          Invoice Paid
        </div>

        <div class="label">
          Total Amount Paid
        </div>

        <div class="amount">
          Rs:${amountClean}
        </div>

      </div>

    </div>

    <table class="items">

      <thead>
        <tr>
          <th>NO. ITEM DESCRIPTION</th>
          <th>PRICE</th>
          <th>TOTAL</th>
        </tr>
      </thead>

      <tbody>

        <tr>

          <td>
            1&nbsp;&nbsp;
            <strong>
              ${(payment.description || "TUITION FEE").toUpperCase()}
            </strong>
          </td>

          <td>
            Rs.${amountClean}
          </td>

          <td>
            Rs.${amountClean}
          </td>

        </tr>

      </tbody>

    </table>

    <table class="totals">

      <tr>
        <td style="width:60%"></td>
        <td>
          <strong>SUB TOTAL</strong>
        </td>
        <td>
          Rs.${amountClean}
        </td>
      </tr>

      <tr>
        <td></td>
        <td class="grand">
          <strong>Grand Total</strong>
        </td>
        <td class="grand">
          Rs.${amountClean}
        </td>
      </tr>

    </table>

    <div class="footer-row">

      <div class="payment-method">
        Payment Method : ${payment.mode || ""}
      </div>

      <div class="signature">
        Authorised Signatory Stamp
      </div>

    </div>

  </div>`;
};
const buildInvoiceHtml = (
    payment,
    academicYear,
    student
) => {
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8" />
<title>Invoice ${payment.invoice}</title>
<style>
  * { box-sizing: border-box; }
  html, body {
    margin: 0;
    padding: 0;
    font-family: Arial, Helvetica, sans-serif;
    background: #ffffff;
  }
  @page {
    size: A4;
    margin: 10mm;
  }
  .page {
    width: 190mm;
    min-height: 277mm;
    margin: 0 auto;
    padding: 6mm 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .invoice-box {
    border: 3px solid #1a2bd6;
    border-radius: 6px;
    padding: 18px 24px;
  }
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
  }
  .brand {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .brand-badge {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    border-radius: 50%;
    background: #f4b400;
    color: #1a2bd6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 9px;
    text-align: center;
    border: 2px solid #1a2bd6;
  }
  .brand-name {
    color: #1a2bd6;
    font-weight: 800;
    font-size: 16px;
    line-height: 1.15;
  }
  .header-right {
    text-align: right;
    flex-shrink: 0;
  }
  .invoice-title {
    color: #1a2bd6;
    font-size: 26px;
    font-weight: 800;
    white-space: nowrap;
  }
  .meta {
    margin-top: 6px;
    font-size: 12px;
    color: #222;
    line-height: 1.5;
  }
  .meta-label {
    font-weight: 700;
    display: inline-block;
    min-width: 78px;
    text-align: left;
  }
  .duplicate-label {
    font-weight: 800;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
  }
  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 22px;
    gap: 16px;
  }
  .bill-to {
    font-size: 13px;
    color: #444;
  }
  .bill-to-label {
    color: #444;
  }
  .bill-to .name {
    color: #1a2bd6;
    font-weight: 800;
    font-size: 16px;
    margin: 4px 0;
  }
  .paid-box {
    text-align: right;
    flex-shrink: 0;
  }
  .paid-box .label { color: #444; font-size: 12px; }
  .paid-box .amount {
    color: #1a2bd6;
    font-weight: 800;
    font-size: 18px;
    margin-top: 2px;
  }
  table.items {
    width: 100%;
    border-collapse: collapse;
    margin-top: 18px;
  }
  table.items thead th {
    background: #1a2bd6;
    color: #fff;
    text-align: left;
    padding: 8px 10px;
    font-size: 12px;
  }
  table.items thead th:nth-child(2),
  table.items thead th:nth-child(3) {
    text-align: right;
  }
  table.items tbody td {
    padding: 9px 10px;
    border-bottom: 1px solid #e2e2e2;
    font-size: 12px;
  }
  table.items tbody td:nth-child(2),
  table.items tbody td:nth-child(3) {
    text-align: right;
  }
  .totals {
    width: 100%;
    margin-top: 4px;
  }
  .totals td {
    padding: 5px 10px;
    font-size: 12px;
    text-align: right;
  }
  .totals .grand {
    background: #1a2bd6;
    color: #fff;
    font-weight: 800;
    font-size: 14px;
  }
  .footer-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 20px;
  }
  .payment-method { font-weight: 700; font-size: 12px; }
  .signature {
    color: #1a2bd6;
    text-decoration: underline;
    font-weight: 600;
    font-size: 12px;
  }
  @media print {
    .page { min-height: 0; }
    .invoice-box { break-inside: avoid; }
  }
</style>
</head>
<body>
  <div class="page">
${renderInvoiceBox(
    payment,
    academicYear,
    student,
    false
)}

${renderInvoiceBox(
    payment,
    academicYear,
    student,
    true
)}
  </div>
  <script>
    window.onload = function () { window.print(); };
  </script>
</body>
</html>`;
};


const CollectFee = () => {

    // ==========================================
    // STUDENT
    // ==========================================
	const [payments, setPayments] = useState([]);
	const [studentList, setStudentList] = useState([]);
	const [selectedStudent, setSelectedStudent] = useState(null);

	const [academicYear, setAcademicYear] = useState("");
	const [academicYears, setAcademicYears] = useState([]);

	const [curriculum, setCurriculum] = useState("");
	const [classFilter, setClassFilter] = useState("");
	const [sectionFilter, setSectionFilter] = useState("");
    const [feeRows, setFeeRows] = useState([]);
	const [classes, setClasses] = useState([]);
	const [sections, setSections] = useState([]);
	const [curriculums, setCurriculums] = useState([]);

	const [showFeePayment, setShowFeePayment] =
		useState(false);

	const [paymentMode, setPaymentMode] = useState("");

	const [paymentDescription, setPaymentDescription] =
		useState("");

	const [invoiceDate, setInvoiceDate] = useState(
		new Date().toISOString().split("T")[0]
	);

	const [savingPayment, setSavingPayment] =
		useState(false);

    // ==========================================
    // FILTERS
    // ==========================================

    const [admNoFilter, setAdmNoFilter] =
        useState("");

    const [statusFilter, setStatusFilter] =
        useState("All Status");

    const [searchKeyword, setSearchKeyword] =
        useState("");


    // ==========================================
    // ACADEMIC YEARS
    // ==========================================



    // ==========================================
    // FEE PAYMENT
    // ==========================================

    const [showAddFee, setShowAddFee] =
        useState(false);


    // ==========================================
    // SEARCH SUGGESTIONS
    // ==========================================

    const [showSuggestions, setShowSuggestions] =
        useState(false);


    // ==========================================
    // ADD FEE
    // ==========================================

    const [newFeeAmount, setNewFeeAmount] =
        useState("");

    const [newFeeDescription, setNewFeeDescription] =
        useState("");

    const [newFeeDueDate, setNewFeeDueDate] =
        useState("");


    // ==========================================
    // LOAD STUDENTS
    // ==========================================
const downloadInvoice = (payment) => {
    const html = buildInvoiceHtml(
        payment,
        academicYear,
        selectedStudent
    );

    const blob = new Blob(
        [html],
        { type: "text/html" }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download =
        `Invoice-${payment.invoice}.html`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
};
    
const loadStudents = async () => {
    try {
        const params = {
            academic_year: academicYear || "",
            curriculum: curriculum || "",
            class: classFilter || "",
            section: sectionFilter || "",
            admission_no: admNoFilter.trim(),
            keyword: searchKeyword.trim(),
        };

        console.log("Student Search Params:", params);

        const response = await feesAPI.searchStudentFees(params);

        const data =
            response.data?.results ||
            response.data ||
            [];

        setStudentList(Array.isArray(data) ? data : []);

    } catch (error) {
        console.error(
            "Student Search Error:",
            error.response?.data || error
        );

        setStudentList([]);
    }
};
	useEffect(() => {
    const hasFilter =
        curriculum ||
        classFilter ||
        sectionFilter ||
        admNoFilter.trim() ||
        searchKeyword.trim();

    if (!hasFilter) {
        setStudentList([]);
        return;
    }

    loadStudents();
}, [
    curriculum,
    classFilter,
    sectionFilter,
    admNoFilter,
    searchKeyword,
]);


	const loadFilterData = async () => {
    try {
        const [
            academicRes,
            classRes,
            sectionRes,
            curriculumRes
        ] = await Promise.all([
            studentsAPI.academicYears(),
            studentsAPI.classes(),
            studentsAPI.sections(),
            feesAPI.curriculums()
        ]);

        setAcademicYears(
            academicRes.data?.results || academicRes.data || []
        );

        setClasses(
            classRes.data?.results || classRes.data || []
        );

        setSections(
            sectionRes.data?.results || sectionRes.data || []
        );

        setCurriculums(
            curriculumRes.data?.results || curriculumRes.data || []
        );

    } catch (error) {
        console.error("Failed to load fee filters:", error);

        setAcademicYears([]);
        setClasses([]);
        setSections([]);
        setCurriculums([]);
    }
};
useEffect(() => {
    loadFilterData();
}, []);
	const hasActiveFilter =
		curriculum !== "" ||
		classFilter !== "" ||
		sectionFilter !== "" ||
		admNoFilter.trim() !== "" ||
		statusFilter !== "All Status" ||
		searchKeyword.trim() !== "";

const searchSuggestions = useMemo(() => {
    const kw = searchKeyword.trim().toLowerCase();

    if (!kw) {
        return [];
    }

    return studentList.filter((student) => {
        const studentName = String(
            student.studentName ||
            student.name ||
            ""
        ).toLowerCase();

        const fatherName = String(
            student.fatherName ||
            ""
        ).toLowerCase();

        const guardianName = String(
            student.guardianName ||
            ""
        ).toLowerCase();

        const admissionNo = String(
            student.admissionNo ||
            student.admission_number ||
            ""
        ).toLowerCase();

        return (
            studentName.includes(kw) ||
            fatherName.includes(kw) ||
            guardianName.includes(kw) ||
            admissionNo.includes(kw)
        );
    });
}, [studentList, searchKeyword]);

    const handleSaveFee = () => {
        if (!newFeeAmount) return;

        const amountNum = Number(newFeeAmount) || 0;
        const dueDateLabel = newFeeDueDate
            ? new Date(newFeeDueDate).toLocaleDateString("en-US", {
                  month: "long",
                  day: "numeric",
                  year: "numeric",
              })
            : "";

        const newRow = {
            id: feeRows.length ? Math.max(...feeRows.map((r) => r.id)) + 1 : 1,
            feeName: newFeeDescription || "NEW FEE",
            dueDate: dueDateLabel,
            actualFee: amountNum,
            discount: 0,
            paid: 0,
            currentDue: amountNum,
            addOnDiscount: "",
            payingAmount: "",
        };

        setFeeRows((prev) => [...prev, newRow]);

        // reset form
        setNewFeeAmount("");
        setNewFeeDescription("");
        setNewFeeDueDate("");
        setShowAddFee(false);
    };
const handleFeePayment = async (student) => {
    try {
        setSelectedStudent(student);
        setShowFeePayment(true);

        if (student.academicYearId) {
            setAcademicYear(String(student.academicYearId));
        }

        const installments = Array.isArray(student.installments)
            ? student.installments
            : [];

        /*
         * Load payment history for this student
         */
        let paymentHistory = [];

        try {
            const historyResponse =
                await feesAPI.paymentHistory(student.id);

            paymentHistory =
                historyResponse.data?.results ||
                historyResponse.data ||
                [];

            if (!Array.isArray(paymentHistory)) {
                paymentHistory = [];
            }

            setPayments(paymentHistory);
        } catch (historyError) {
            console.error(
                "Payment history loading error:",
                historyError.response?.data || historyError
            );
        }

        /*
         * Calculate TOTAL PAID amount
         * for each StudentFeeInstallment
         */
        const paidByInstallment = {};

        paymentHistory.forEach((payment) => {

            const items = Array.isArray(payment.items)
                ? payment.items
                : [];

            items.forEach((item) => {

                const installmentId = Number(
                    item.student_fee_installment
                );

                const amountPaid = Number(
                    item.amount_paid || 0
                );

                if (!installmentId) {
                    return;
                }

                paidByInstallment[installmentId] =
                    (paidByInstallment[installmentId] || 0) +
                    amountPaid;
            });
        });

        console.log(
            "PAID BY INSTALLMENT:",
            paidByInstallment
        );

        /*
         * Build fee rows
         */
        const rows = installments.map((term) => {

            const installmentId = Number(term.id);

            const actualFee = Number(
                term.amount || 0
            );

            const discount = Number(
                term.discount || 0
            );

            /*
             * IMPORTANT:
             * Paid amount comes from Payment History
             */
            const paid = Number(
                paidByInstallment[installmentId] || 0
            );

            /*
             * Existing add-on discount
             */
            const existingAddOnDiscount = Number(
                term.add_on_discount || 0
            );

            /*
             * Current Due
             */
            const currentDue = Math.max(
                actualFee -
                discount -
                paid -
                existingAddOnDiscount,
                0
            );

            console.log(
                "INSTALLMENT:",
                installmentId,
                {
                    actualFee,
                    discount,
                    paid,
                    existingAddOnDiscount,
                    currentDue
                }
            );

            return {
                /*
                 * MUST be StudentFeeInstallment ID
                 */
                id: installmentId,

                feeName:
                    term.fee_name ||
                    term.installment_name ||
                    "Fee",

                dueDate:
                    term.due_date || "",

                actualFee,

                discount,

                /*
                 * CUMULATIVE PAID
                 */
                paid,

                existingAddOnDiscount,

                currentDue,

                /*
                 * New discount for current payment
                 */
                addOnDiscount: 0,

                /*
                 * New payment
                 */
                payingAmount: 0,
            };
        });

        console.log(
            "FINAL FEE ROWS:",
            rows
        );

        setFeeRows(rows);

    } catch (error) {

        console.error(
            "Error loading fee payment:",
            error.response?.data || error
        );

        setFeeRows([]);
    }
};
const handleAddOnDiscount = (id, value) => {
    const addOnDiscount = Math.max(
        Number(value) || 0,
        0
    );

    setFeeRows((prev) =>
        prev.map((row) => {
            if (row.id !== id) {
                return row;
            }

            const baseDue =
                Number(row.actualFee || 0) -
                Number(row.discount || 0) -
                Number(row.paid || 0);

            const currentDue = Math.max(
                baseDue - addOnDiscount,
                0
            );

            return {
                ...row,
                addOnDiscount: value,
                currentDue,
            };
        })
    );
};
const handlePayingAmount = (id, value) => {
    setFeeRows((prev) =>
        prev.map((row) => {
            if (row.id !== id) {
                return row;
            }

            const amount = Number(value) || 0;

            const maxPayable =
                Number(row.currentDue || 0);

            return {
                ...row,
                payingAmount:
                    amount > maxPayable
                        ? maxPayable
                        : value,
            };
        })
    );
};
const totals = useMemo(() => {

    return feeRows.reduce(
        (acc, row) => {

            acc.actualFee +=
                Number(row.actualFee) || 0;

            acc.discount +=
                Number(row.discount) || 0;

            acc.addOnDiscount +=
                Number(row.addOnDiscount) || 0;

            acc.paid +=
                Number(row.paid) || 0;

            acc.currentDue +=
                Number(row.currentDue) || 0;

            acc.payingAmount +=
                Number(row.payingAmount) || 0;

            return acc;
        },
        {
            actualFee: 0,
            discount: 0,
            addOnDiscount: 0,
            paid: 0,
            currentDue: 0,
            payingAmount: 0,
        }
    );

}, [feeRows]);

const handleSubmitPayment = async () => {
    console.log("========== SUBMIT PAYMENT ==========");

    if (!selectedStudent?.id) {
        alert("Please select a student.");
        return;
    }

    if (!academicYear) {
        alert("Please select Academic Year.");
        return;
    }

    if (!paymentMode) {
        alert("Please select Payment Mode.");
        return;
    }

    const rowsToPay = feeRows
        .filter((row) => {
            const payingAmount = Number(row.payingAmount || 0);
            const addOnDiscount = Number(row.addOnDiscount || 0);

            return payingAmount > 0 || addOnDiscount > 0;
        })
        .map((row) => ({
            // IMPORTANT:
            // This must be StudentFeeInstallment.id
            installment_id: Number(row.id),

            paying_amount: Number(row.payingAmount || 0),

            add_on_discount: Number(row.addOnDiscount || 0),
        }));

    console.log("Rows To Pay:", rowsToPay);

    if (!rowsToPay.length) {
        alert("Please enter Paying Amount or Add On Discount.");
        return;
    }

    const payload = {
        student_id: selectedStudent.id,
        academic_year: academicYear,
        invoice_date: invoiceDate,
        payment_mode: paymentMode,
        description: paymentDescription || "",
        fee_rows: rowsToPay,
    };

    console.log("Payment Payload:", payload);

    try {
        setSavingPayment(true);

        const response = await feesAPI.collectPayment(payload);

        console.log("Payment API Response:", response.data);

        alert(
            `Payment saved successfully.${
                response.data?.payment?.invoice_number
                    ? ` Invoice: ${response.data.payment.invoice_number}`
                    : ""
            }`
        );

        // Refresh fee rows
        await handleFeePayment(selectedStudent);

        // Refresh payment history
        await loadPaymentHistory(selectedStudent.id);

        setPaymentMode("");
        setPaymentDescription("");

    } catch (error) {
        console.error(
            "Payment Save Error:",
            error.response?.data || error
        );

        const errorMessage =
            error.response?.data?.error ||
            error.response?.data?.detail ||
            error.response?.data?.message ||
            "Failed to save payment.";

        alert(errorMessage);

    } finally {
        setSavingPayment(false);
    }
};

const [loadingPayments, setLoadingPayments] = useState(false);


const loadPaymentHistory = async (studentId) => {
    if (!studentId) {
        setPayments([]);
        return;
    }

    try {
        setLoadingPayments(true);

        const response = await feesAPI.paymentHistory(studentId);

        console.log("PAYMENT HISTORY RESPONSE:", response.data);

        const data =
            response.data?.results ||
            response.data ||
            [];

        setPayments(Array.isArray(data) ? data : []);

    } catch (error) {
        console.error(
            "PAYMENT HISTORY ERROR:",
            error.response?.data || error
        );

        setPayments([]);
    } finally {
        setLoadingPayments(false);
    }
};
useEffect(() => {
    if (selectedStudent?.id) {
        loadPaymentHistory(selectedStudent.id);
    } else {
        setPayments([]);
    }
}, [selectedStudent?.id]);
const paidByInstallment = {};

payments.forEach((payment) => {
    (payment.items || []).forEach((item) => {
        const installmentId = Number(item.student_fee_installment);

        if (!installmentId) return;

        paidByInstallment[installmentId] =
            (paidByInstallment[installmentId] || 0) +
            Number(item.amount_paid || 0);
    });
});

useEffect(() => {
    loadPaymentHistory(selectedStudent?.id);
}, [selectedStudent?.id]);

    const formatRs = (val) =>
        val === "" || val === undefined ? "" : `Rs. ${Number(val).toLocaleString("en-IN")}`;

    return (
        <>
            {/* ============================
          COLLECT FEE SECTION
      ============================ */}
            {!showFeePayment && (
                <section className="collect-fee">
                    <div className="page-header">
                        <h2>Collect Fee</h2>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-sm-4 col-lg-2 mb-3">
                                    <label className="form-label">Curriculum</label>
									<select
										className="form-select"
										value={curriculum}
										onChange={(e) => setCurriculum(e.target.value)}
									>
										<option>--- Select ---</option>
										<option>SSC</option>
										<option>CBSE</option>
									</select>
										</div>

                                <div className="col-sm-4 col-lg-2 mb-3">
                                    <label className="form-label">Class</label>
									<select
										className="form-select"
										value={classFilter}
										onChange={(e) => setClassFilter(e.target.value)}
									>
										<option value="">--- Select ---</option>

										{classes.map((cls) => (
											<option
												key={cls.id}
												value={cls.id}
											>
												{cls.name}
											</option>
										))}
									</select>
                                </div>

                                <div className="col-sm-4 col-lg-2 mb-3">
                                    <label className="form-label">Section</label>
									<select
										className="form-select"
										value={sectionFilter}
										onChange={(e) => setSectionFilter(e.target.value)}
									>
										<option value="">--- Select ---</option>

										{sections.map((section) => (
											<option
												key={section.id}
												value={section.id}
											>
												{section.name}
											</option>
										))}
									</select>
                                </div>

                                <div className="col-sm-4 col-lg-2 mb-3">
                                    <label className="form-label">Admission No</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={admNoFilter}
                                        onChange={(e) => setAdmNoFilter(e.target.value)}
                                    />
                                </div>

                                <div className="col-sm-4 col-lg-2 mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        className="form-select"
                                        value={statusFilter}
                                        onChange={(e) => setStatusFilter(e.target.value)}
                                    >
                                        <option>All Status</option>
                                        <option>Paid</option>
                                        <option>Pending</option>
                                        <option>Partial</option>
                                        <option>Waived</option>
                                    </select>
                                </div>

                                <div className="col-sm-4 col-lg-2 mb-3 position-relative">
                                    <label className="form-label">Search by key word</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={searchKeyword}
                                        onChange={(e) => {
                                            setSearchKeyword(e.target.value);
                                            setShowSuggestions(true);
                                        }}
                                        onFocus={() => {
                                            if (searchKeyword.trim()) setShowSuggestions(true);
                                        }}
                                        onBlur={() => {
                                            // allow click on suggestion to register before closing
                                            setTimeout(() => setShowSuggestions(false), 150);
                                        }}
                                        placeholder="Name, father / guardian"
                                        autoComplete="off"
                                    />

                                    {showSuggestions && searchKeyword.trim() && (
                                        <ul
                                            className="list-group position-absolute w-100 shadow-sm"
                                            style={{ zIndex: 1000, top: "100%" }}
                                        >
                                            {searchSuggestions.length === 0 && (
                                                <li className="list-group-item text-muted small">
                                                    No matching students
                                                </li>
                                            )}

                                            {searchSuggestions.map((s) => (
                                                <li
                                                    key={s.id}
                                                    className="list-group-item list-group-item-action py-2"
                                                    style={{ cursor: "pointer" }}
                                                    onMouseDown={() => {
                                                        setSearchKeyword(s.studentName);
                                                        setShowSuggestions(false);
                                                    }}
                                                >
                                                    <div className="fw-semibold">{s.studentName}</div>
                                                    <div className="small text-muted">
                                                        Father/Guardian: {s.guardianName || s.fatherName}
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>

                            {hasActiveFilter ? (
                                <>
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <h5>List Of Students</h5>
                                    </div>

                                    <div className="table-responsive mt-3 border">
                                        <table className="table align-middle mb-0">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Class</th>
                                                    <th>Student Name</th>
                                                    <th>Father Name</th>
                                                    <th>Mobile</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>

												<tbody>
													{studentList.length > 0 ? (
														studentList.map((student, index) => (
															<tr key={student.id || index}>
																<td>
																	{index + 1}
																</td>

																<td>
																	{student.className ||
																		student.class ||
																		"-"}
																</td>

																<td>
																	{student.studentName ||
																		student.name ||
																		"-"}
																</td>

																<td>
																	{student.guardianName ||
																		student.fatherName ||
																		"-"}
																</td>

																<td>
																	{student.phone ||
																		student.mobileNumber ||
																		"-"}
																</td>

																<td>
																	<button
																		type="button"
																		className="btn btn-primary btn-sm"
																		onClick={() =>
																			handleFeePayment(student)
																		}
																	>
																		Collect Fee
																	</button>
																</td>
															</tr>
														))
													) : (
														<tr>
															<td
																colSpan="6"
																className="text-center text-muted py-4"
															>
																No students found
															</td>
														</tr>
													)}
												</tbody>
                                        </table>
                                    </div>
                                </>
                            ) : (
                                <div className="alert alert-light border text-muted mt-3 mb-0">
                                    Use the filters or search above to find students.
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            )}

            {/* ============================
          FEE PAYMENT SECTION
      ============================ */}
            {showFeePayment && (
                <section className="CollecteFeeUpdate">
                    <div className="page-header d-flex justify-content-between align-items-center">
                        <h2>Fee Payment</h2>

                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowFeePayment(false)}
                        >
                            ← Back
                        </button>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered align-middle">
                                    <thead>
                                        <tr>
                                            <th>RFID.No</th>
                                            <th>Adm. No</th>
                                            <th>Student Name</th>
                                            <th>Surname</th>
                                            <th>Guardian Name</th>
                                            <th>Mobile Number</th>
                                            <th>Class</th>
                                            <th>Section</th>
                                        </tr>
                                    </thead>

<tbody>
    <tr>
        <td>{selectedStudent?.rfidNo || "-"}</td>

        <td>
            {selectedStudent?.admissionNo ||
                selectedStudent?.admNo ||
                "-"}
        </td>

        <td>
            {selectedStudent?.studentName ||
                selectedStudent?.name ||
                "-"}
        </td>

        <td>
            {selectedStudent?.surname || "-"}
        </td>

        <td>
            {selectedStudent?.guardianName ||
                selectedStudent?.fatherName ||
                "-"}
        </td>

        <td>
            {selectedStudent?.phone ||
                selectedStudent?.mobileNumber ||
                "-"}
        </td>

        <td>
            {selectedStudent?.className ||
                selectedStudent?.class ||
                "-"}
        </td>

        <td>
            {selectedStudent?.sectionName ||
                selectedStudent?.section ||
                "-"}
        </td>
    </tr>
</tbody>
                                </table>
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-4">
                                    <label className="form-label fw-semibold">
                                        Select Academic Year
                                    </label>

									<select
									className="form-select"
									value={academicYear}
									onChange={(e) =>
										setAcademicYear(e.target.value)
									}
								>
									<option value="">
										--- Select ---
									</option>

									{academicYears.map((year) => (
										<option
											key={year.id}
											value={year.id}
										>
											{year.name}
										</option>
									))}
								</select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {!academicYear && (
                        <div className="alert alert-warning mt-3">
                            Please select an Academic Year above to view and manage fee details.
                        </div>
                    )}

                    {academicYear && (
                    <div className="mt-3">
                        {/* add fee  section start */}
                        <div className="mt-3">
                            <button
                                className="btn btn-primary btn-sm mb-2"
                                onClick={() => setShowAddFee(!showAddFee)}
                            >
                                Add Fee
                            </button>

                            {showAddFee && (
                                <div className="card mb-3 shadow-sm">
                                    <div className="card-header bg-primary text-white">
                                        Add New Fee
                                    </div>

                                    <div className="card-body">
                                        <div className="row g-3">
                                            <div className="col-md-3">
                                                <label className="form-label">Fee Amount</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter Amount"
                                                    value={newFeeAmount}
                                                    onChange={(e) => setNewFeeAmount(e.target.value)}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="form-label">Fee Description</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Fee Description"
                                                    value={newFeeDescription}
                                                    onChange={(e) => setNewFeeDescription(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label">Fee Due Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={newFeeDueDate}
                                                    onChange={(e) => setNewFeeDueDate(e.target.value)}
                                                />
                                            </div>

                                            <div className="col-md-3 text-center mt-4">
                                                <button
                                                    className="btn btn-success me-2 mt-2"
                                                    onClick={handleSaveFee}
                                                    disabled={!newFeeAmount}
                                                >
                                                    Save Fee
                                                </button>

                                                <button
                                                    className="btn btn-secondary  mt-2"
                                                    onClick={() => setShowAddFee(false)}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* add fee  section end */}

                        <div className="card my-4">
                            <div className="card-body">
                                <h6 className="text-secondary">
                                    Please Note: 1. Add On Discount can be applied when only on making the
                                    payment
                                </h6>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>S.No:</th>
                                                <th>Fee Details:</th>
                                                <th>Due Date</th>
                                                <th>Actual Fee</th>
                                                <th>Discounts</th>
                                                <th>Paid Amount</th>
                                                <th>Current Due</th>
                                                <th>Add On Discount</th>
                                                <th>Paying Amount</th>
                                            </tr>
                                        </thead>

										<tbody>
											{feeRows.map((row, index) => (
												<tr key={row.id}>
													<td>{index + 1}</td>

													<td>{row.feeName}</td>

													<td>{row.dueDate}</td>

													<td>{formatRs(row.actualFee)}</td>

													<td>
														{row.discount
															? formatRs(row.discount)
															: ""}
													</td>

													<td>
														{row.paid
															? row.paid.toLocaleString("en-IN")
															: 0}
													</td>

													<td>
														{row.currentDue !== ""
															? formatRs(row.currentDue)
															: ""}
													</td>

													{/* Add On Discount */}
													<td>
														{row.currentDue !== "" &&
														Number(row.currentDue) !== 0 ? (
															<input
																type="number"
																className="form-control mb-1"
																placeholder="Discount Amount"
																value={row.addOnDiscount || ""}
																onChange={(e) =>
																	handleAddOnDiscount(
																		row.id,
																		e.target.value
																	)
																}
															/>
														) : null}
													</td>

													{/* Paying Amount */}
													<td>
														{row.currentDue !== "" &&
														Number(row.currentDue) !== 0 ? (
															<input
																type="number"
																className="form-control"
																placeholder="Enter Amount"
																value={row.payingAmount || ""}
																onChange={(e) =>
																	handlePayingAmount(
																		row.id,
																		e.target.value
																	)
																}
															/>
														) : null}
													</td>
												</tr>
											))}

											{/* TOTALS */}
											<tr className="fw-bold">
												<td></td>
												<td></td>
												<td></td>

												<td>
													{formatRs(totals.actualFee)}
												</td>

												<td>
													{formatRs(totals.discount)}
												</td>

												<td>
													{formatRs(totals.paid)}
												</td>

												<td>
													{formatRs(totals.currentDue)}
												</td>

												<td>
													{formatRs(totals.addOnDiscount)}
												</td>

												<td>
													{formatRs(totals.payingAmount)}
												</td>
											</tr>

											{/* TOTAL DUE */}
											<tr>
												<td colSpan="4"></td>

												<td className="fw-bold">
													Total Due
												</td>

												<td className="fw-bold">
													{formatRs(totals.currentDue)}
												</td>

												<td colSpan="3"></td>
											</tr>

											{/* INVOICE DATE */}
											<tr>
												<td colSpan="4"></td>

												<td className="fw-bold">
													Invoice Date:
												</td>

												<td colSpan="2">
													<input
														type="date"
														className="form-control"
														defaultValue="2026-05-31"
													/>
												</td>

												<td colSpan="2"></td>
											</tr>

											{/* PAYMENT MODE + DESCRIPTION */}
											<tr>
												<td colSpan="4"></td>

												<td className="fw-bold">
													Payment&nbsp;mode:
												</td>

												<td colSpan="2">
													<select
    className="form-select"
    value={paymentMode}
    onChange={(e) => {
        setPaymentMode(e.target.value);
        console.log("Selected Payment Mode:", e.target.value);
    }}
>
    <option value="">--- Select Payment Mode ---</option>
    <option value="cash">Cash</option>
    <option value="online">Online</option>
    <option value="cheque">Cheque</option>
    <option value="dd">DD</option>
    <option value="upi">UPI</option>
</select>
												</td>

												<td className="fw-bold">
													Description:
												</td>

												<td>
													<textarea
														rows="3"
														className="form-control"
													></textarea>
												</td>
											</tr>

											{/* SUBMIT PAYMENT */}
											<tr>
												<td colSpan="5"></td>

												<td>
													<button
													type="button"
													className="btn btn-success"
													onClick={handleSubmitPayment}
													disabled={savingPayment}
												>
													{savingPayment ? "Saving..." : "Submit Payment"}
												</button>
												</td>

												<td colSpan="3"></td>
											</tr>
										</tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {/* history section start */}
                   {academicYear && (
                    <div className="card my-4">
                        <div className="card-body">
                            <h5 className="fw-bold mb-4">Payment History</h5>

                            <div className="table-responsive border">
                <table className="table table-bordered table-striped">

                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Invoice No</th>
                            <th>Receipt No</th>
                            <th>Invoice Date</th>
                            <th>Amount Due</th>
                            <th>Discount</th>
                            <th>Paid Amount</th>
                            <th>Payment Mode</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody>

                        {payments.map((payment, index) => (

                            <tr key={payment.id}>

                                <td>
                                    {index + 1}
                                </td>

                                <td>
                                    {payment.invoice_number || "-"}
                                </td>

                                <td>
                                    {payment.receipt_number || "-"}
                                </td>

                                <td>
                                    {payment.invoice_date || "-"}
                                </td>

                                <td>
                                    ₹
                                    {Number(
                                        payment.amount_due || 0
                                    ).toLocaleString("en-IN")}
                                </td>

                                <td>
                                    ₹
                                    {Number(
                                        payment.discount || 0
                                    ).toLocaleString("en-IN")}
                                </td>

                                <td>
                                    <strong>
                                        ₹
                                        {Number(
                                            payment.amount_paid || 0
                                        ).toLocaleString("en-IN")}
                                    </strong>
                                </td>

                                <td>
                                    {payment.payment_mode || "-"}
                                </td>

                                <td>
                                    <span className="badge bg-success">
                                        {payment.status || "-"}
                                    </span>
                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>
                            </div>
                        </div>
                    </div>
                    )}
                    {/* history section end */}
                </section>
            )}
        </>
    );
};

export default CollectFee;